import React, { useState } from "react";
import MCheckbox from "../../components/ui/atoms/MCheckbox";

const CheckboxTest: React.FC = () => {
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  return (
    <div style={{ padding: 32 }}>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24 }}>
        MCheckbox States
      </h2>
      <div style={{ display: "flex", gap: 32 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <MCheckbox checked={false} />
          <span style={{ marginTop: 8 }}>Unselected</span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <MCheckbox checked={true} />
          <span style={{ marginTop: 8 }}>Selected</span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <MCheckbox indeterminate />
          <span style={{ marginTop: 8 }}>Indeterminate</span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <MCheckbox disabled />
          <span style={{ marginTop: 8 }}>Disabled Off</span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <MCheckbox checked disabled />
          <span style={{ marginTop: 8 }}>Disabled On</span>
        </div>
      </div>
      <div style={{ height: 40 }} />
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>
        Interactive Example
      </h2>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <MCheckbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={() => setChecked((c) => !c)}
        />
        <button onClick={() => setChecked((c) => !c)} style={{ padding: 8 }}>
          Toggle Checked
        </button>
        <button
          onClick={() => setIndeterminate((i) => !i)}
          style={{ padding: 8 }}
        >
          Toggle Indeterminate
        </button>
      </div>
    </div>
  );
};

export default CheckboxTest;
